import { NavLink } from "react-router-dom";
import React from "react"; //{ useState, useEffect, useRef }
import style from "../style/footer.module.css";

function Footer() {
  return (
    <>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
      />

      <div className={style.footB}>
        <div className={style.footDiv}>
          <div className={style.logoH}>
            <img src="/images/logo.png" alt="img" className={style.logo} />
          </div>

          <div className={style.footDiv1}>
            <div className={style.footLeft}>
              <div className={style.footText}>
                <p className={style.contactText}>
                  Your Trusted Travel Companion
                </p>

                <p className={style.footText1}>
                  Explore new destinations with ease—book rides, guides, and
                  stays all in one app. Travel smarter, travel with Pulo.
                </p>
              </div>

              <span className={style.social}>
                <img src="./images/ig.png" alt="" />
                <img src="./images/linkedin.png" alt="" />
                <img src="./images/twitter.png" alt="" />
                <img src="./images/mail.png" alt="" />
                <img src="./images/fb.png" alt="" />
              </span>
            </div>

            {/* <div className={style.footNav}> */}
            {/* <div className={style.contact}>
              <h4 className={style.contactText}>Contact</h4>
              <p className={style.p}> +1 (346) 575-4852</p>
              <p className={style.p}>info@gtexthomesusa.com</p>
              <p className={style.p}>518, Westgreen Blvd. Katy, Texas, 77450</p>
            </div> */}
            {/* </div> */}

            {/* <div className={style.contact}> */}
            <ul className={style.navUl}>
              <li className={style.navLi}>
                <NavLink to="/">Home</NavLink>
              </li>

              <li className={style.navLi}>
                <NavLink to="/about">About</NavLink>
              </li>

              <li className={style.navLi}>
                <NavLink to="/booking">Bookings</NavLink>
              </li>

              <li className={style.navLi}>
                <NavLink to="/stays">Stays</NavLink>
              </li>

              <li className={style.navLi}>
                <NavLink to="/how">How It Works</NavLink>
              </li>
            </ul>
            {/* </div> */}
          </div>
        </div>

        <div className={style.copyTerm}>
          <p className={style.copy}>© Copyright 2025.</p>

          {/* <ul className={style.termPriv}>
              <li className={style.copy}>
                <NavLink to="/t&c">Terms </NavLink>
              </li>

              <li className={style.copy}>
                <NavLink to="/privacy-policy">Privacy</NavLink>
              </li>
            </ul> */}
        </div>
      </div>
    </>
  );
}

export default Footer;
